module.exports = __webpack_public_path__ + "static/media/business-growth-bg.87bf315a.jpg";